import { render } from "./calculator.vue?vue&type=template&id=20ffcdd0&scoped=true"
import script from "./calculator.vue?vue&type=script&lang=js"
export * from "./calculator.vue?vue&type=script&lang=js"

import "./calculator.vue?vue&type=style&index=0&id=20ffcdd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ffcdd0"]])

export default __exports__